import styled from 'styled-components';

export const InfoContainer = styled.div`
  padding: 12px 12px 12px 0;

  font-size: 16px;
  line-height: 24px;
`;
